export default "__VITE_ASSET__BRNZ5Q$d__"